// Vendors
import React from 'react';
// Components
import { LayoutFooterComponent } from './components/footer/layout-footer.component';
import { LayoutSkeletonComponent } from './components/skeleton/layout-skeleton.component';
import { LayoutOperationalComponent } from './components/operational/layout-operational.component';
// Contexts
import { FetchErrorContextConsumerHOC } from 'contexts/fetch-error.context';
import { LayoutContextConsumerHOC } from './contexts/layout.context';
// Hooks
import { useLayoutHook } from './hooks/layout.hook';
// Styles
import { LayoutComponentStyled, LayoutFetchingComponentStyled } from './layout.component.styled';
// Types
import { LayoutType } from './types/layout.type';
// Utilities
import { layoutIsFetching } from './utils/layout.utils';

const LayoutBaseComponent = ({
  fetchResolver,
  externalFetching,
  ...restProps
}: LayoutType): React.JSX.Element | React.ReactNode => {
  const { compactView, fetching, ...layoutHookData } = useLayoutHook({ fetchResolver });

  return fetching ? (
    <LayoutFetchingComponentStyled fetching={layoutIsFetching({ fetching, externalFetching })}>
      <LayoutSkeletonComponent />
    </LayoutFetchingComponentStyled>
  ) : (
    <LayoutFetchingComponentStyled fetching={layoutIsFetching({ fetching, externalFetching })}>
      <LayoutComponentStyled compactView>
        <LayoutOperationalComponent {...{ ...restProps, ...layoutHookData }} />
        <LayoutFooterComponent {...{ externalFetching }} />
      </LayoutComponentStyled>
    </LayoutFetchingComponentStyled>
  );
};

const LayoutComponent = LayoutContextConsumerHOC(FetchErrorContextConsumerHOC(LayoutBaseComponent));

export { LayoutComponent };
